import { SITE_ORIGIN } from './siteConfig';

export const SERVICE_PILLAR_SLUGS = ['ecommerce', 'booking-systems', 'local-seo'];

export const SOUTH_WEST_HUB_SLUGS = [
  { slug: 'plymouth', label: 'Plymouth' },
  { slug: 'exeter', label: 'Exeter' },
  { slug: 'torbay', label: 'Torbay' },
  { slug: 'truro', label: 'Truro' },
  { slug: 'falmouth', label: 'Falmouth' },
  { slug: 'barnstaple', label: 'Barnstaple' }
];

const PILLARS = {
  ecommerce: {
    path: '/services/ecommerce',
    title: 'E-commerce solutions for South West retailers | WebCodeCraft',
    description:
      'High-conversion e-commerce for St Ives, Padstow, Truro & independent retailers: Shopify or WooCommerce-grade stores, inventory & shipping workflows, no large upfront build.',
    h1: 'E-commerce solutions',
    lede:
      'Transform your local shop into a global storefront. We specialize in high-conversion e-commerce platforms tailored for South West independent retailers.',
    body: [
      'From artisan makers in St Ives to boutiques in Padstow, we build secure, fast online stores that handle inventory management and automated shipping workflows aligned with how you actually trade. Our monthly-first model applies here too: a professional Shopify or WooCommerce-grade store without a typical four-figure upfront agency invoice.',
      'We scope payment gateways, product structure, and fulfilment touchpoints so your team spends less time on admin and more time on stock and customers.'
    ],
    caseTitle: 'How we deliver',
    caseBody:
      'We typically start with catalogue structure and checkout goals, then wire secure payments, shipping rules, and analytics so you can see which products and regions perform. Larger integrations stay quoted separately against the care tier you choose.',
    ctaTitle: 'Get started',
    ctaBody: 'Tell us your platform preference and catalogue size—we will reply with a clear next step.'
  },
  'booking-systems': {
    path: '/services/booking-systems',
    title: 'Online booking systems for tourism & services | WebCodeCraft',
    description:
      'Mobile-first booking for Newquay, Torbay & hospitality: calendars, deposits, reminders—turn visitors into confirmed guests without heavy upfront build costs.',
    h1: 'Online booking systems',
    lede:
      'Turn website visitors into confirmed guests. For tourism-driven economies like Newquay and the English Riviera, a seamless booking experience is the difference between a bounce and a sale.',
    body: [
      'We integrate advanced, mobile-first booking flows for holiday lets, surf schools, and professional services. Systems sync with your calendar in real time, process secure deposits, and send automated reminders so you focus on guests while the site handles admin.',
      'Performance and clarity stay in scope: fast loads on 4G, clear cancellation and deposit copy, and structured data where it helps discovery.'
    ],
    caseTitle: 'What good looks like',
    caseBody:
      'A typical build pairs availability logic with email or SMS confirmations, optional payment holds, and a dashboard-friendly export so you can reconcile alongside your existing tools.',
    ctaTitle: 'Get started',
    ctaBody: 'Share your booking rules and peak season—we will outline integration options that match your operations.'
  },
  'local-seo': {
    path: '/services/local-seo',
    title: 'Local SEO strategy — map pack & geo signals | WebCodeCraft',
    description:
      'Local SEO for trades & professionals across our service towns: Google Map Pack focus, schema, geo landing pages—built into how we ship sites.',
    h1: 'Local SEO strategy',
    lede:
      'Be the first business they see on the map. A strong site is only half the battle; visibility in the Google Map Pack is where revenue often moves.',
    body: [
      'Our local SEO pillar is built into every site we ship: we strengthen geo signals so that when someone searches for your service in their town, you are in the running for the map pack and organic results. We handle structured data, align with your Google Business Profile messaging, and support location-specific landing pages across the areas we publish.',
      'That applies to service-based SMEs—plumbers, lawyers, accountants, electricians, builders, carpenters, plasterers, flooring firms, carpet fitters, and similar trades—whether you operate from one postcode or several.'
    ],
    caseTitle: 'Practical focus',
    caseBody:
      'We combine crawlable location copy, consistent NAP-style signals on-page, performance basics, and review and CTA patterns that match how people search on mobile.',
    ctaTitle: 'Get started',
    ctaBody: 'Tell us your primary towns and services—we will map a realistic local visibility plan to your tier.'
  }
};

export function getServicePillar(slug) {
  if (!slug || typeof slug !== 'string') return null;
  return PILLARS[String(slug).toLowerCase()] || null;
}

export function getServicePillarMeta(slug) {
  const p = getServicePillar(slug);
  if (!p) return null;
  return {
    title: p.title,
    description: p.description,
    canonical: `${SITE_ORIGIN}${p.path}`
  };
}
